import { injectable } from 'inversify';
import { createSelector } from '@reduxjs/toolkit';
import { AssessmentRepository } from '../../state/reduxRepositories';
import { Assessment } from '../../state/reduxRepositories/assessments/assessments.interfaces';
import { AssessmentSummaryQueryService } from './assessmentSummary.queryParam.service';
import { useAppSelector } from '../../state/hooks';

@injectable()
export class AssessmentSummaryDomain {
  selectedAssessment: any;

  public constructor(
    private assessmentRepository: AssessmentRepository,
    private assessmentSummaryQueryService: AssessmentSummaryQueryService,
  ) {
    this.createSelectedAssessmentSelector();
  }

  useAssessmentSelector = (): Assessment | undefined => {
    return useAppSelector(this.selectedAssessment);
  };

  createSelectedAssessmentSelector = () => {
    this.selectedAssessment = createSelector(
      this.assessmentSummaryQueryService.mergedQuerySelector,
      this.assessmentRepository.selectors.resourcesSelector,
      (queryParam: any, assessments): Assessment | undefined => {
        return assessments.find(
          (assessment) => assessment.id === queryParam.selectedAssessmentId,
        );
      },
    );
  };
}
